import { graphql } from "@/lib/gql/__generated__";
import { ReservationRequestStatus } from "@/lib/gql/__generated__/graphql";

import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { useHotelApplicationDataQuery } from "@/components/features/_shared/repository/hotel-application-data/query";

const Initialize_Query = graphql(/* GraphQL */ `
	query ReservationRequestListByMonthCount(
		$hotelID: ID!
		$months: Int!
		$reservationRequestStatus: ReservationRequestStatus!
	) {
		reservationRequestListByMonthCount(
			hotelID: $hotelID
			months: $months
			reservationRequestStatus: $reservationRequestStatus
		) {
			id
			hotelID
			hotelName
			reservations {
				hotelID
				reservationID
				reservationType
				reservationStatus
			}
		}
	}
`);

type Props = {
	hotelID: string;
};

export const useInitialize = ({ hotelID }: Props) => {
	const { data } = useCustomSuspenseQuery(Initialize_Query, {
		variables: { hotelID, months: 3, reservationRequestStatus: ReservationRequestStatus.Unnoticed },
	});

	const { hotelApplicationData } = useHotelApplicationDataQuery(hotelID);

	return {
		data: data!,
		isHostDirectReservationAvailable:
			hotelApplicationData?.hotelApplicationStatus.isHostDirectReservationAvailable ?? false,
	};
};
